import { SSMLTag } from "shared/constants";

/**
 * Rules for disabling SSML menus based on tag nesting
 * - Key: The tag type for which this rule applies (the menu button to potentially disable)
 * - Value: Array of tag types that would cause this menu to be disabled if the selection is inside them
 *
 * Based on the SSML tag nesting rules:
 * - <say-as> should be disabled if selection is inside <say-as>, <break>, <phoneme>.
 * - <phoneme> should be disabled if selection is inside <say-as>, <phoneme>, <break>.
 * - <prosody> should be disabled if selection is inside <say-as>, <phoneme>, <prosody>, <emphasis>, <break>.
 * - <emphasis> should be disabled if selection is inside <say-as>, <phoneme>, <emphasis>, <break>.
 * - <voice> should be disabled if selection is inside <say-as>, <phoneme>, <break>, <voice>.
 * - <lang> should be disabled if selection is inside <say-as>, <phoneme>, <break>, <lang>.
 * - <style> should be disabled if selection is inside <say-as>, <phoneme>.
 */
export const disablingRules: Record<string, string[]> = {
  [SSMLTag.SayAs]: [
    SSMLTag.SayAs, SSMLTag.Phoneme,  SSMLTag.Break],
  [SSMLTag.Phoneme]: [
    SSMLTag.SayAs, SSMLTag.Phoneme, SSMLTag.Break
  ],

  [SSMLTag.Prosody]: [SSMLTag.Prosody],
  [SSMLTag.Emphasis]: [SSMLTag.Emphasis],
  [SSMLTag.Style]: [SSMLTag.Style],

  [SSMLTag.Voice]: [SSMLTag.Voice],
  [SSMLTag.Language]: [SSMLTag.Language],

  [SSMLTag.Break]: [SSMLTag.Break],
};




